/*       */

import styled from 'styled-components';

const Block = styled.div`
    display: block;
`;

export default Block;
